import React from 'react';

import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';

import { Box, Stack, Typography } from '@mui/material';

import { getExternalId } from '~/components/Accommodation/utils/rates';

import { PricingIssue, Rate } from '~/services/AccommodationService';

interface PricingIssueContentProps {
  pricingIssue: PricingIssue;
}

export default function PricingIssueContent({ pricingIssue }: PricingIssueContentProps) {
  const rate = pricingIssue.rate as Rate;
  return (
    <Stack spacing={1}>
      <Typography>Rate: {rate.id}</Typography>
      <Typography>
        External Id: {rate.meta.type} {getExternalId(rate)}
      </Typography>
      <Typography fontWeight="bold">Errors</Typography>
      {pricingIssue.errors.map((error, i) => (
        <Typography key={i}>{error}</Typography>
      ))}
      <Box height={'70vh'} fontSize="small" overflow="auto">
        <ReactDiffViewer
          oldValue={''}
          newValue={JSON.stringify(pricingIssue.rate, null, 2)}
          leftTitle={'Accommodation Rate Data'}
          rightTitle={'dsadsa'}
          splitView={false}
          extraLinesSurroundingDiff={5}
          compareMethod={DiffMethod.WORDS}
        />
      </Box>
    </Stack>
  );
}
